import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    border: '1px solid #dcdcdc',
    borderRadius: 8,
    overflow: 'hidden',
    backgroundColor: '#ffffff',
  },
  toolbar: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: '6px 12px',
    backgroundColor: '#f8fafc',
    borderBottom: '1px solid #e2e8f0',
    gap: 4,
    position: 'sticky',
    top: 0,
    zIndex: 10,
  },
  toolbarGroup: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 2,
    paddingRight: 6,
    borderRight: '1px solid #e0e0e0',
    marginRight: 4,
  },
  iconButton: {
    padding: 6,
    borderRadius: 4,
    color: '#4a5568',
    transition: 'all 0.15s ease',
    '&:hover': {
      backgroundColor: '#edf2f7',
      color: theme.palette.primary.main,
    },
  },
  iconButtonActive: {
    backgroundColor: '#e8f0fe !important',
    color: '#1a73e8 !important',
    borderRadius: 4,
    boxShadow: 'inset 0 0 0 1px #bad3fc',
  },
  selectFormat: {
    fontSize: 13,
    minWidth: 110,
    height: 32,
    marginRight: 6,
  },
  insertVariableBtn: {
    backgroundColor: theme.palette.primary.main,
    color: '#ffffff',
    fontWeight: 600,
    fontSize: 12,
    textTransform: 'none',
    borderRadius: 6,
    padding: '4px 12px',
    height: 32,
    boxSizing: 'border-box',
    display: 'inline-flex',
    alignItems: 'center',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  btnVistaPreviaToolbar: {
    borderColor: '#059669',
    color: '#059669',
    fontWeight: 600,
    fontSize: 12,
    textTransform: 'none',
    borderRadius: 6,
    padding: '4px 10px',
    height: 32,
    boxSizing: 'border-box',
    display: 'inline-flex',
    alignItems: 'center',
    marginLeft: 6,
    '&:hover': {
      backgroundColor: '#ecfdf5',
      borderColor: '#047857',
      color: '#047857',
    },
    '&.Mui-disabled': {
      borderColor: '#d1d5db',
      color: '#9ca3af',
    },
  },
  documentContainer: {
    padding: 0,
    overflowY: 'auto',
    overflowX: 'auto',
    maxHeight: '75vh',
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    backgroundColor: '#ffffff',
  },
  sheetPage: {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    minHeight: 420,
    boxSizing: 'border-box',
    backgroundColor: '#ffffff',
    padding: '24px 32px',
    boxShadow: 'none',
    border: 'none',
    borderRadius: 0,
    outline: 'none',
    fontFamily: '"Times New Roman", Times, serif, "Roboto", Arial',
    fontSize: 15,
    lineHeight: 1.65,
    color: '#2d3748',
    whiteSpace: 'pre-wrap !important',
    wordBreak: 'break-word !important',
    overflowWrap: 'break-word !important',
    '&:empty::before': {
      content: 'attr(data-placeholder)',
      color: '#a0aec0',
      pointerEvents: 'none',
      display: 'block',
    },
    '& p, & div, & span, & h1, & h2, & h3, & h4, & h5, & h6, & li, & b, & strong': {
      wordBreak: 'break-word !important',
      overflowWrap: 'break-word !important',
      whiteSpace: 'pre-wrap !important',
    },
    '& p': {
      margin: '0 0 12px 0',
    },
    '& h1': {
      fontSize: '1.8rem',
      fontWeight: 'bold',
      margin: '16px 0 8px 0',
      textAlign: 'center',
    },
    '& h2': {
      fontSize: '1.4rem',
      fontWeight: 'bold',
      margin: '14px 0 6px 0',
    },
    '& h3': {
      fontSize: '1.2rem',
      fontWeight: 'bold',
      margin: '12px 0 4px 0',
    },
    '& blockquote': {
      margin: '12px 0',
      paddingLeft: 16,
      borderLeft: '3px solid #cbd5e0',
      fontStyle: 'normal',
    },
    '& table': {
      width: '100%',
      borderCollapse: 'collapse',
      margin: '14px 0',
    },
    '& table:not(.tabla-sin-bordes):not(.tabla-lineas-horizontales), & table.tabla-con-bordes': {
      border: '1px solid #718096',
    },
    '& table:not(.tabla-sin-bordes):not(.tabla-lineas-horizontales) th, & table:not(.tabla-sin-bordes):not(.tabla-lineas-horizontales) td, & table.tabla-con-bordes th, & table.tabla-con-bordes td': {
      border: '1px solid #718096',
      padding: '8px 12px',
    },
    '& table.tabla-sin-bordes': {
      border: 'none !important',
    },
    '& table.tabla-sin-bordes th, & table.tabla-sin-bordes td': {
      border: '1px dashed #cbd5e1 !important',
      padding: '8px 12px',
    },
    '& table.tabla-lineas-horizontales': {
      borderTop: '2px solid #718096 !important',
      borderBottom: '2px solid #718096 !important',
      borderLeft: 'none !important',
      borderRight: 'none !important',
    },
    '& table.tabla-lineas-horizontales th, & table.tabla-lineas-horizontales td': {
      borderTop: '1px solid #e2e8f0 !important',
      borderBottom: '1px solid #e2e8f0 !important',
      borderLeft: 'none !important',
      borderRight: 'none !important',
      padding: '8px 12px',
    },
    '& th': {
      backgroundColor: '#f7fafc',
      fontWeight: 'bold',
    },
    '& b.variable-wrapper-bold': {
      fontWeight: 'bold',
      display: 'inline',
    },
    '& .variable-chip': {
      display: 'inline-flex',
      alignItems: 'center',
      backgroundColor: '#e8f0fe',
      color: '#1a73e8',
      border: '1px solid #bad3fc',
      borderRadius: 4,
      padding: '1px 6px',
      fontSize: '0.85em',
      fontWeight: 500,
      margin: '0 2px',
      verticalAlign: 'baseline',
      userSelect: 'all',
      cursor: 'pointer',
      transition: 'all 0.15s ease-in-out',
      '&:hover': {
        filter: 'brightness(0.96)',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      },
      '&.chip-bold, b > &, strong > &': {
        backgroundColor: '#eff6ff',
        color: '#1d4ed8',
        border: '1.5px solid #2563eb',
        fontWeight: 'bold !important',
        boxShadow: '0 1px 3px rgba(37, 99, 235, 0.2)',
      },
      '&.chip-bold::before, b > &::before, strong > &::before': {
        content: '"B"',
        display: 'inline-block',
        backgroundColor: '#1d4ed8',
        color: '#ffffff',
        fontSize: '9px',
        fontWeight: 900,
        lineHeight: '12px',
        padding: '0 4px',
        borderRadius: 2,
        marginRight: 4,
        letterSpacing: '0.5px',
      },
    },
    '& .page-break': {
      display: 'flex',
      alignItems: 'center',
      margin: '24px 0',
      userSelect: 'none',
      cursor: 'default',
      '&::before, &::after': {
        content: '""',
        flex: 1,
        borderTop: '1px dashed #cbd5e1',
      },
      '& .page-break-label': {
        padding: '3px 14px',
        margin: '0 12px',
        backgroundColor: '#f8fafc',
        border: '1px solid #cbd5e1',
        borderRadius: 14,
        fontSize: 11,
        fontWeight: 600,
        color: '#64748b',
        letterSpacing: '0.4px',
        textTransform: 'uppercase',
      },
    },
  },
  statusBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '6px 16px',
    backgroundColor: '#ffffff',
    borderTop: '1px solid #e2e8f0',
    fontSize: 12,
    color: '#64748b',
    fontWeight: 500,
  },
  statusBarGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  statusBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    backgroundColor: '#f1f5f9',
    padding: '2px 8px',
    borderRadius: 4,
    color: '#475569',
    fontSize: 11,
  },
  menuItemCategory: {
    fontSize: 11,
    fontWeight: 700,
    textTransform: 'uppercase',
    color: '#718096',
    backgroundColor: '#f7fafc',
    padding: '6px 16px',
    letterSpacing: '0.5px',
  },
  menuItemVariable: {
    fontSize: 13,
    padding: '6px 16px',
    display: 'flex',
    justifyContent: 'space-between',
    '&:hover': {
      backgroundColor: '#edf2f7',
      color: theme.palette.primary.main,
    },
  },
  variableTagPreview: {
    fontSize: 11,
    color: '#718096',
    fontFamily: 'monospace',
    marginLeft: 12,
  },
  searchField: {
    padding: '8px 12px',
    borderBottom: '1px solid #e2e8f0',
  },
  tableContextGroup: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 2,
    padding: '2px 8px',
    backgroundColor: '#eff6ff',
    borderRadius: 6,
    border: '1px solid #bfdbfe',
    marginRight: 4,
  },
  tableContextLabel: {
    fontSize: 11,
    fontWeight: 700,
    color: '#1d4ed8',
    marginRight: 4,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  tableMenuItemIcon: {
    minWidth: 28,
    color: '#475569',
  },
}));
